import { queryOptions } from "@tanstack/react-query";
// import Cookies from "js-cookie";
import {
  fetchAllAttendanceRequestsForEmployee,
  fetchAllLeadRemindersOfEmployee,
  fetchAllLeads,
  fetchAllPerformanceLogsOfEmployeeForEmployee,
  fetchAllPerformanceReportsForEmployee,
  fetchAllSalaryOfEmployeeForEmployee,
  fetchAllTimesheetsByYearForEmployee,
  fetchSingleLeadLogForEmployee,
  getAllAllowanceRequestsOfEmployees,
  getAllAllowanceRequestsOfOtherEmployeesAsApprover,
  getAllAnnouncementsForEmployee,
  getAllLeaveApplicationsOfCurrentEmployee,
  getAllLeaveApplicationsOfOtherEmployeesAsApprover,
  getAllLoanRequestsForEmployee,
  getAllSalaryOfEmployeeForEmployee,
  getAttendanceByMonthYearForEmployee,
  getAttendanceForEmployee,
  getCheckinsOfEmployeesDayWise,
  getCurrentEmployee,
  getCurrentEmployeeCheckins,
  getLoanRepaymentRequestsOfEmployee,
  getSingleLeaveApplicationForEmployee,
  getSingleLoanRequestForEmployee,
  getTodayBreakStatus,
} from "./employee/emp-queries";
import { getActiveCompanyHolidayListEmployee } from "./company-holiday-queries";
// import { fetchCurrentEmployeeNotifications } from "./employee/emp-notification-queries";
import {
  getAllPendingTodosForEmployee,
  getAllTodosForEmployee,
  getStatusOfTodoForEmployee,
  getTodoForEmployee,
} from "./employee/emp-todo-queries";

// const EMP_KEY = Cookies.get("key") as string;

// || *********************** QUERY OPTIONS ******************** ||

export const getCurrentEmployeeQueryOptions = (key: string) =>
  queryOptions({
    queryKey: ["employee"],
    queryFn: () => getCurrentEmployee(key),
    refetchOnWindowFocus: false,
    enabled: !!key,
  });

export const getCurrentEmployeeCheckinsQueryOptions = (key: string) =>
  queryOptions({
    queryKey: ["employee", "checkin"],
    queryFn: () => getCurrentEmployeeCheckins(key),
  });

export const getAllLeaveApplicationOfCurrentEmployeeQueryOptions = (
  employeeKey: string
) =>
  queryOptions({
    queryKey: ["employee", "leave-applications"],
    queryFn: () => getAllLeaveApplicationsOfCurrentEmployee(employeeKey),
    refetchOnWindowFocus: false,
    refetchInterval: 20000,
  });

export const getOneLeaveApplicationForEmployeeQueryOptions = (
  employeeKey: string,
  leaveId: string
) =>
  queryOptions({
    queryKey: ["employee-leave", leaveId],
    queryFn: () => getSingleLeaveApplicationForEmployee(employeeKey)(leaveId),
    refetchOnWindowFocus: false,
  });

export const getAllLeaveApplicationOfOtherEmployeesAsApproverQueryOptions = (
  employeeKey: string,
  isApprover: boolean,
  status?: string
) =>
  queryOptions({
    queryKey: ["employee", "leave-applications", "approver", status],
    queryFn: () =>
      getAllLeaveApplicationsOfOtherEmployeesAsApprover(employeeKey, status),
    enabled: isApprover && status !== "",
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const getAllAllowanceRequestsOfOtherEmployeesAsApproverQueryOptions = (
  employeeKey: string,
  isApprover: boolean,
  status?: string
) =>
  queryOptions({
    queryKey: ["employee", "allowance-requests", "approver", status],
    queryFn: () =>
      getAllAllowanceRequestsOfOtherEmployeesAsApprover(employeeKey, status),
    enabled: isApprover && status !== "",
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const fetchAllLeadsQueryOptions = (
  employeeKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    status?: string;
  }
) =>
  queryOptions({
    queryKey: ["leads", data],
    queryFn: () => fetchAllLeads(employeeKey)(data),
    refetchInterval: 5000,
  });

export const fetchAllLeadsWithConditionQueryOptions = (
  employeeKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    status?: string;
  },
  enabledFn: () => boolean
) =>
  queryOptions({
    queryKey: ["leads", data],
    queryFn: () => fetchAllLeads(employeeKey)(data),
    refetchInterval: 5000,
    enabled: enabledFn(),
  });

export const fetchAllLeadRemindersQueryOptions = (employeeKey: string) =>
  queryOptions({
    queryKey: ["lead-reminders"],
    queryFn: () => fetchAllLeadRemindersOfEmployee(employeeKey),
    refetchOnWindowFocus: false,
  });

export const getAllAllowanceRequestsOfEmployeeQueryOptions = (
  employeeKey: string,
  status?: string
) =>
  queryOptions({
    queryKey: ["allowances", status],
    queryFn: () => getAllAllowanceRequestsOfEmployees(employeeKey)(status),
    refetchOnWindowFocus: false,
    refetchInterval: 20000,
  });

export const getAllLoanRequestsForEmployeeQueryOptions = (
  employeeKey: string,
  status?: string
) =>
  queryOptions({
    queryKey: ["employee-loans", status],
    queryFn: () => getAllLoanRequestsForEmployee(employeeKey)(status),
    refetchOnWindowFocus: false,
    enabled: status !== "",
    // refetchInterval: 20000,
  });

export const getOneLoanRequestForEmployeeQueryOptions = (
  employeeKey: string,
  loanId: string
) =>
  queryOptions({
    queryKey: ["employee-loan", loanId],
    queryFn: () => getSingleLoanRequestForEmployee(employeeKey)(loanId),
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const getLoanRepaymentRequestsQueryOptions = (
  employeeKey: string,
  loanId: string
) =>
  queryOptions({
    queryKey: ["employee-repayment-requests", loanId],
    queryFn: () => getLoanRepaymentRequestsOfEmployee(employeeKey)(loanId),
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const getAttendanceForEmployeeQueryOptions = (
  employeeKey: string,
  startdate: Date,
  enddate: Date
) =>
  queryOptions({
    queryKey: ["employee-attendance", startdate, enddate],
    queryFn: () =>
      getAttendanceForEmployee(employeeKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: false,

    // refetchInterval: 300000,
  });

export const getAttendanceByMonthYearForEmployeeQueryOptions = (
  employeeKey: string,
  monthName: string,
  year: number
) =>
  queryOptions({
    queryKey: ["employee-attendance-by-monthyear", monthName, year],
    queryFn: () =>
      getAttendanceByMonthYearForEmployee(employeeKey)({
        monthName,
        year,
      }),
    refetchOnWindowFocus: false,
    enabled: monthName !== "",

    // refetchInterval: 300000,
  });

export const fetchAllTimesheetsByYearForEmployeeQueryOptions = (
  adminKey: string,
  data: {
    year: number;
  }
) =>
  queryOptions({
    queryKey: ["timesheets-month", data],
    queryFn: () => fetchAllTimesheetsByYearForEmployee(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
  });

export const fetchAllAttendanceRequestForEmployeeQueryOptions = (
  employeeKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    status?: string;
  }
) =>
  queryOptions({
    queryKey: ["emp-attendance-requests", data],
    queryFn: () => fetchAllAttendanceRequestsForEmployee(employeeKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
    refetchInterval: 20000,
  });

// ? NOTIFICATIONS QUERY OPTIONS ? //
// export const fetchCurrentEmployeeAllNotificationsQueryOptions = (
//   employeeKey: string,
//   isSeen?: boolean,
//   limit?: number
// ) =>
//   infiniteQueryOptions({
//     queryKey: ["employee-notifications"],
//     queryFn: () =>
//       fetchCurrentEmployeeNotifications({
//         employeeKey,
//         isSeen,
//         limit,
//       }),
//     getNextPageParam(lastPage, allPages) {
//       return lastPage.length > 0 ? allPages.length + 1 : undefined;
//     },
//     initialPageParam: 0,
//   });

export const getOneLeadLogsForEmployeeQueryOptions = (
  empKey: string,
  leadId: string
) =>
  queryOptions({
    queryKey: ["lead-logs", leadId],
    queryFn: () => fetchSingleLeadLogForEmployee(empKey)(leadId),
    refetchOnWindowFocus: false,
    enabled: !!leadId,
  });

export const getAllAnnouncementsForEmployeeQueryOptions = (
  employeeKey: string,
  startdate: Date,
  enddate: Date
) =>
  queryOptions({
    queryKey: ["empoyee-announcements", startdate, enddate],
    queryFn: () =>
      getAllAnnouncementsForEmployee(employeeKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: false,

    refetchInterval: 300000,
  });

export const getAllSalaryOfEmployeeForEmployeeQueryOptions = (
  empKey: string,
  period: {
    start: Date;
    end: Date;
  }
) =>
  queryOptions({
    queryKey: ["employee-salary", period],
    queryFn: () => fetchAllSalaryOfEmployeeForEmployee(empKey)(period),
    refetchOnWindowFocus: false,
  });

export const getAllSalaryOfEmployeeDirectForEmployeeQueryOptions = (
  empKey: string
) =>
  queryOptions({
    queryKey: ["employee-all-salary"],
    queryFn: () => getAllSalaryOfEmployeeForEmployee(empKey),
    refetchOnWindowFocus: false,
  });

// ! TODOS QUERY OPTIONS ! //
export const getAllTodosForEmployeeQueryOptions = (
  employeeKey: string,
  startdate: Date,
  enddate: Date
) =>
  queryOptions({
    queryKey: ["empoyee-todos", startdate, enddate],
    queryFn: () =>
      getAllTodosForEmployee(employeeKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: false,

    // refetchInterval: 300000,
  });

// ! TODOS QUERY OPTIONS ! //
export const getAllPendingTodosForEmployeeQueryOptions = (
  employeeKey: string
) =>
  queryOptions({
    queryKey: ["empoyee-pending-todos"],
    queryFn: () => getAllPendingTodosForEmployee(employeeKey)({}),
    // refetchOnWindowFocus: false,

    refetchInterval: 3000,
  });

export const getStatusOfTodoForEmployeeQueryOptions = (
  employeeKey: string,
  todoId: string
) =>
  queryOptions({
    queryKey: ["empoyee-todo-status"],
    queryFn: () => getStatusOfTodoForEmployee(employeeKey)(todoId),
    refetchOnWindowFocus: true,
    enabled: !!todoId,
    refetchInterval: 10000,
  });

export const getTodoForEmployeeQueryOptions = (
  employeeKey: string,
  todoId: string
) =>
  queryOptions({
    queryKey: ["empoyee-todo"],
    queryFn: () => getTodoForEmployee(employeeKey)(todoId),
    refetchOnWindowFocus: false,
    enabled: !!todoId,
    refetchInterval: 300000,
  });

export const fetchAllPerformanceLogsOfEmployeeForEmployeeQueryOptions = (
  empKey: string,
  data: {
    startdate: Date;
    enddate: Date;
  }
) =>
  queryOptions({
    queryKey: ["emp-performance-logs", data],
    queryFn: () => fetchAllPerformanceLogsOfEmployeeForEmployee(empKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
    refetchInterval: 20000,
  });

export const fetchAllPerformanceReportsForEmployeeQueryOptions = (
  empKey: string,
  need: {
    month?: string;
    year: number;
  }
) =>
  queryOptions({
    queryKey: ["performance-reports", need],
    queryFn: () => fetchAllPerformanceReportsForEmployee(empKey)(need),
    refetchOnWindowFocus: false,
    enabled: need.month !== "",
  });

export const getCurrentEmployeeCheckinsDayWiseQueryOptions = (
  employeeKey: string,
  day: Date
) =>
  queryOptions({
    queryKey: ["current-employee-checkins", day],
    queryFn: () =>
      getCheckinsOfEmployeesDayWise(employeeKey)({
        date: day,
      }),
    refetchOnWindowFocus: false,
    enabled: !!employeeKey, // Only run if key is available
  });

// ! COMPANY HOLIDAYS QUERY OPTIONS ! //
export const getActiveCompanyHolidayListForEmployeeQueryOptions = (
  employeeKey: string,
  year?: number
) =>
  queryOptions({
    queryKey: ["company-holiday-active-employee", year],
    queryFn: () => getActiveCompanyHolidayListEmployee(employeeKey)(year),
    refetchOnWindowFocus: false,
  });

// Polled: the break state is server-side so a reload or a second device agrees.
export const getTodayBreakStatusQueryOptions = (employeeKey: string) =>
  queryOptions({
    queryKey: ["employee", "break-today"],
    queryFn: () => getTodayBreakStatus(employeeKey),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    enabled: !!employeeKey,
  });
